import { CustomFieldType } from 'src/services/custom-fields/custom-field.types';

/**
 * Marks a list column key as a custom field. The suffix is the config id, so the key survives a
 * field being renamed — which is what lets a user's saved column layout survive it too.
 *
 * Mirrors CUSTOM_FIELD_COLUMN_PREFIX in backend/src/common/utils/custom-field-list.util.ts.
 */
export const CUSTOM_FIELD_COLUMN_PREFIX = 'cf:';

export const customFieldColumnKey = (configId: string): string =>
  `${CUSTOM_FIELD_COLUMN_PREFIX}${configId}`;

/** One custom field's value as the list endpoints return it, keyed by config id on the row. */
export interface CustomFieldCellValue {
  type: CustomFieldType;
  text?: string | null;
  boolean?: boolean | null;
  options?: { id: string; label: string }[];
}

/** A list row that may carry custom field values. */
export interface RowWithCustomFields {
  custom_fields?: Record<string, CustomFieldCellValue>;
}
